export const MORE_LINKS = [
	{
		text: {
			default: "¿Qué es la lectura digital?",
			translationId: "links.digital_reading",
		},
		link: "/que-es",
	},
	{
		text: {
			default: "Blog",
			translationId: "links.blog",
		},
		link: "/blog",
	},
	{
		text: {
			default: "Centro de recursos",
			translationId: "links.marketing_center",
		},
		link: "/centro-de-recursos",
	},
	{
		text: {
			default: "MakeMake en Vivo",
			translationId: "links.makemake_live",
		},
		link: "/club-makemake?section=makemake-en-vivo",
	},
	{
		text: {
			default: "Casos de éxito",
			translationId: "links.success_stories",
		},
		link: "/club-makemake?section=planes-de-lectura",
	},
];

export const PRODUCTS_LINKS = [
	{
		text: {
			default: "Conoce más sobre MakeMake",
			translationId: "links.about_makemake",
		},
		link: "/acerca-de-makemake",
	},
	{
		text: {
			default: "MakeMake para colegios",
			translationId: "links.schools",
		},
		link: "/que-es/colegios",
	},
	{
		text: {
			default: "MakeMake para bibliotecas públicas",
			translationId: "links.public_libraries",
		},
		link: "/que-es/bibliotecas",
	},
	{
		text: {
			default: "Academia MakeMake",
			translationId: "links.academia",
		},
		link: "https://academia.makemake.com.co/login",
		external: true,
	},
	{
		text: {
			default: "Hogares y familias",
			translationId: "links.homes",
		},
		link: "/tienda/plan-casa",
	},
	{
		text: {
			default: "Accesibilidad y privacidad de datos",
			translationId: "links.accessibility_privacy",
		},
		link: "/politica-de-privacidad",
	},
	{
		text: {
			default: "Declaración de accesibilidad",
			translationId: "links.accessibility_statement",
		},
		link: "/accesibility-statement",
	},
	{
		text: {
			default: "Política de desarrollo de colección",
			translationId: "links.collection_development",
		},
		link: "/collection-development-policy",
	},
];
